import { render, staticRenderFns } from "./SetClipartLayer.vue?vue&type=template&id=3c6ee757"
import script from "./SetClipartLayer.vue?vue&type=script&lang=js"
export * from "./SetClipartLayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports